import { useCallback } from "react";
import { clientFetch } from "@flights/client-fetch";
import useContextName from "./useContextName.js";
export default function useMetrics() {
    const contextName = useContextName();
    const trackMetrics = useCallback((nameSpace, nodeName, breakdowns, type) => {
        void clientFetch("/track/metrics", {
            method: "POST",
            body: JSON.stringify({ nameSpace, nodeName, breakdowns, type }),
            headers: {
                "Content-Type": "application/json",
                "X-Flights-Context-Name": contextName
            }
        }).catch(() => { });
    }, [contextName]);
    return { trackMetrics };
}
